import {PageService, PreviewService} from 'hasta-la-vista-middleware-api/service'
import ContentSection from '../../content/sections';
export default {
    name: 'content_page',

    created () {
        PreviewService.clear();

        if (this.$route.params.content_type && this.$route.params.node_id) {
            PageService.getNode(this.$route.params.node_id).then((pageContent)=> {
                if (pageContent && typeof pageContent === 'object' && Object.keys(pageContent).length > 0) {

                    PreviewService.setContent(this.$route.params.content_type, pageContent);
                    PreviewService.loadPimaryRoute(this.$router);
                }
            })
        }
    },

    template: `<div class="payment">
		<div class="default__bg"></div>
		<sk-container>
			<sk-panel>
		    <div  class="loading">
		        <sk-progress-circular indeterminate size="100" :width="2" primary></sk-progress-circular>
		        <h4>Loading Preview data.</h4>
		    </div>
			</sk-panel>
		</sk-container>
	</div>`

}



// WEBPACK FOOTER //
// ./src/components/pages/content/preview.js